export default __webpack_public_path__ + "static/media/tick.2f1d7598.svg";